export const INIT_INBOX_SESSION = "INIT_INBOX_SESSION"
export const INIT_INBOX_SESSION_SUCCESS = "INIT_INBOX_SESSION_SUCCESS"
export const INIT_INBOX_SESSION_FAILED = "INIT_INBOX_SESSION_FAILED"
export const SAVE_COMMENT_BOARD_DIALOGS = "SAVE_COMMENT_BOARD_DIALOGS"
export const SAVE_DIRECT_MESSAGE_DIALOGS = "SAVE_DIRECT_MESSAGE_DIALOGS"
export const SAVE_NEWS_FEED_DIALOGS = "SAVE_NEWS_FEED_DIALOGS"
export const SAVE_DIRECT_MESSAGE_USERS = "SAVE_DIRECT_MESSAGE_USERS"
export const INBOX_DISCONNECT = "INBOX_DISCONNECT"

export const GET_INBOX_MESSAGES = "GET_INBOX_MESSAGES"
export const GET_INBOX_MESSAGES_SUCCESS = "GET_INBOX_MESSAGES_SUCCESS"
export const GET_INBOX_MESSAGES_FAILED = "GET_INBOX_MESSAGES_FAILED"

export const RESET_UNREAD_MESSAGE_COUNTER = "RESET_UNREAD_MESSAGE_COUNTER"
export const INCREMENT_UNREAD_MESSAGE_COUNT = "INCREMENT_UNREAD_MESSAGE_COUNT"

export const GET_INBOX_CHAT_USERS = "GET_INBOX_CHAT_USERS"
export const GET_INBOX_CHAT_USERS_SUCCESS = "GET_INBOX_CHAT_USERS_SUCCESS"
export const GET_INBOX_CHAT_USERS_FAILED = "GET_INBOX_CHAT_USERS_FAILED"

export const LOAD_INBOX_MESSAGES = "LOAD_INBOX_MESSAGES"
export const LOAD_INBOX_MESSAGES_SUCCESS = "LOAD_INBOX_MESSAGES_SUCCESS"
export const LOAD_INBOX_MESSAGES_FAILED = "LOAD_INBOX_MESSAGES_FAILED"

export const SAVE_NEW_INBOX_MESSAGE = "SAVE_NEW_INBOX_MESSAGE"

export const GET_MESSAGE_LIKES = "GET_MESSAGE_LIKES"
export const GET_MESSAGE_LIKES_SUCCESS = "GET_MESSAGE_LIKES_SUCCESS"
export const GET_MESSAGE_LIKES_FAILED = "GET_MESSAGE_LIKES_FAILED"

export const UPDATE_MESSAGE_LIKES = "UPDATE_MESSAGE_LIKES"
export const UPDATE_MESSAGE_LIKES_SUCCESS = "UPDATE_MESSAGE_LIKES_SUCCESS"
export const UPDATE_MESSAGE_LIKES_FAILED = "UPDATE_MESSAGE_LIKES_FAILED"

export const SEND_PM_CHAT_NOTIFICATION = "SEND_PM_CHAT_NOTIFICATION"

export const SEND_INBOX_MESSAGE = "SEND_INBOX_MESSAGE"
export const SEND_INBOX_MESSAGE_SUCCESS = "SEND_INBOX_MESSAGE_SUCCESS"
export const SEND_INBOX_MESSAGE_FAILED = "SEND_INBOX_MESSAGE_FAILED"
